import axios from './apiClient';
import { token, domain } from '../components/Security';


//#region Enums Fetch
const enumsUrl = domain + '/api/enums'

export const fetchOTTransactionTypesEnum = async () => {
  const response = await axios.get(enumsUrl + "/transaction-types", {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });

  console.log(response);

  return response.data;
}

export const fetchDropdownTypesEnum = async () => { // updating this, moving to src/v2/useMaintenanceType
  const response = await axios.get(enumsUrl + "/dropdown-types", {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });

  return response.data;
}

export const fetchFormulaTypesEnum = async () => {
  const response = await axios.get(enumsUrl + "/formula-types", {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });

  return response.data;
}

export const fetchDayTypesEnum = async () => {
  const response = await axios.get(enumsUrl + "/day-types", {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });

  return response.data;
}

export const fetchOutputValueTypesEnum = async () => {
  const response = await axios.get(enumsUrl + "/outputvalue-types", {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });

  return response.data;
}

export const fetchDTRTuleConfurationTypesEnum = async () => {
  const response = await axios.get(enumsUrl + "/dtrruleconfiguration-types", {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
  return response.data;
}
//#endregion Enums Fetch







//#region Fetch From DB
export const fetchShiftSchedule = async () => {
  const apiUrl = domain + "/api/ShiftSchedule";
  const response = await axios.get(apiUrl ,{
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });

  return response.data;
}

export const fetchClientIdentity = async () => {
  const apiUrl = domain + "/api/ClientIdentity/get-client-identity"
  const response = await axios.get(apiUrl, {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  })

  return response.data;
}
//#endregion Fetch From DB





export const fetchDropdownValues = async (dropdownType) => {
  if (!dropdownType) return [];

  let apiEndpoint = "";
  switch (parseInt(dropdownType)) {
    case 1: apiEndpoint = "/api/Location"; break;
    case 2: apiEndpoint = "/api/Company"; break;
    case 3: apiEndpoint = "/api/Classification"; break;
    case 4: apiEndpoint = "/api/Employment"; break;
    case 5: apiEndpoint = "/api/Department"; break;
    case 6: apiEndpoint = "/api/Section"; break;
    case 7: apiEndpoint = "/api/PayType"; break;
    case 8: apiEndpoint = "/api/ShiftSchedule"; break;
    case 9: apiEndpoint = "/api/Position"; break;
    case 10: apiEndpoint = "/api/SalaryType"; break;
    case 11: apiEndpoint = "/api/JobTitle"; break;
    case 12: apiEndpoint = "/api/EmployeeGroup1"; break;
    case 13: apiEndpoint = "/api/EmployeeGroup2"; break;
    case 14: apiEndpoint = "/api/Client"; break;
    default:
      console.error("Unknown dropdown type:", dropdownType);
      return [];
  }

  try {
    const response = await axios.get(domain + apiEndpoint, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });



    return response.data.map(item => ({
      value: item.id || item.value,
      label: item.name || item.description || item.title || `ID: ${item.id}`,
    }));

  } catch (error) {
    console.error(`Error fetching dropdown values for type ${dropdownType}:`, error);
    return [];
  }
};

